export default __webpack_public_path__ + "static/media/Mick-Sample.8599a112.jpg";